import { TRANSFER_STATE_STATUS } from '~/constants/transfer'
import { STABLECOIN_FEE_POLLING_TIME } from './const'
import { ActionTypes, StablecoinFeeTimer, State, WITHDRAW_ACTIONS } from './types'

export const initialStablecoinFeeTimer: StablecoinFeeTimer = {
  isRunning: false,
  timeRemaining: STABLECOIN_FEE_POLLING_TIME,
}

export const initialState: State = {
  amount: null,
  bankAccount: null,
  bankNetwork: null,
  blockchainAddress: null,
  blockchainNetwork: null,
  currency: null,
  error: null,
  fiatFee: null,
  stablecoinFee: null,
  stablecoinFeeTimer: initialStablecoinFeeTimer,
  status: TRANSFER_STATE_STATUS.IDLE,
  transferMethod: null,
  transferRemark: null,
  walletId: undefined,
}

export const withdraw = (state = initialState, action: ActionTypes): State => {
  switch (action.type) {
    case WITHDRAW_ACTIONS.COUNTDOWN_STABLECOIN_FEE_TIMER: {
      return {
        ...state,
        stablecoinFeeTimer: {
          ...state.stablecoinFeeTimer,
          timeRemaining: state.stablecoinFeeTimer.timeRemaining - action.payload,
        },
      }
    }
    case WITHDRAW_ACTIONS.RESET_WITHDRAW: {
      return initialState
    }
    case WITHDRAW_ACTIONS.RESTART_STABLECOIN_FEE_TIMER: {
      return {
        ...state,
        stablecoinFeeTimer: {
          ...state.stablecoinFeeTimer,
          timeRemaining: initialStablecoinFeeTimer.timeRemaining,
        },
      }
    }
    case WITHDRAW_ACTIONS.SET_AMOUNT: {
      return {
        ...state,
        amount: action.payload,
      }
    }
    case WITHDRAW_ACTIONS.SET_BANK_ACCOUNT: {
      return {
        ...state,
        bankAccount: action.payload,
      }
    }
    case WITHDRAW_ACTIONS.SET_BANK_NETWORK: {
      return {
        ...state,
        bankNetwork: action.payload,
      }
    }
    case WITHDRAW_ACTIONS.SET_BLOCKCHAIN_ADDRESS: {
      return {
        ...state,
        blockchainAddress: action.payload,
      }
    }
    case WITHDRAW_ACTIONS.SET_BLOCKCHAIN_NETWORK: {
      return {
        ...state,
        blockchainNetwork: action.payload,
      }
    }
    case WITHDRAW_ACTIONS.SET_CURRENCY: {
      return {
        ...state,
        currency: action.payload,
      }
    }
    case WITHDRAW_ACTIONS.SET_ERROR: {
      return {
        ...state,
        error: action.payload,
      }
    }
    case WITHDRAW_ACTIONS.SET_FIAT_FEE: {
      if (!state.currency || !action.payload) {
        return state
      }

      const fiatFee = !state.fiatFee ? {} : { ...state.fiatFee }

      return {
        ...state,
        fiatFee: { ...fiatFee, [state.currency]: action.payload },
      }
    }
    case WITHDRAW_ACTIONS.SET_STABLECOIN_FEE: {
      return {
        ...state,
        stablecoinFee: action.payload,
      }
    }
    case WITHDRAW_ACTIONS.SET_STATUS: {
      return {
        ...state,
        status: action.payload,
      }
    }
    case WITHDRAW_ACTIONS.SET_TRANSFER_METHOD: {
      return {
        ...state,
        transferMethod: action.payload,
      }
    }
    case WITHDRAW_ACTIONS.SET_TRANSFER_REMARK: {
      return {
        ...state,
        transferRemark: action.payload,
      }
    }
    case WITHDRAW_ACTIONS.SET_WALLET_ID: {
      return {
        ...state,
        walletId: action.payload,
      }
    }
    case WITHDRAW_ACTIONS.START_STABLECOIN_FEE_TIMER: {
      return {
        ...state,
        stablecoinFeeTimer: {
          ...state.stablecoinFeeTimer,
          isRunning: true,
        },
      }
    }
    case WITHDRAW_ACTIONS.STOP_STABLECOIN_FEE_TIMER: {
      return {
        ...state,
        stablecoinFeeTimer: initialStablecoinFeeTimer,
      }
    }
    default:
      return state
  }
}
